import * as $runtime from "../runtime.js";
import * as Control$dMonad$dFree from "../Control.Monad.Free/index.js";
import * as Data$dBifunctor from "../Data.Bifunctor/index.js";
import * as Data$dCatList from "../Data.CatList/index.js";
import * as Data$dCatQueue from "../Data.CatQueue/index.js";
import * as Data$dFoldable from "../Data.Foldable/index.js";
import * as Data$dList$dTypes from "../Data.List.Types/index.js";
import * as Data$dMaybe from "../Data.Maybe/index.js";
import * as Halogen$dData$dSlot from "../Halogen.Data.Slot/index.js";
import * as Halogen$dHTML$dCore from "../Halogen.HTML.Core/index.js";
import * as Halogen$dQuery$dHalogenM from "../Halogen.Query.HalogenM/index.js";
import * as Halogen$dVDom$dThunk from "../Halogen.VDom.Thunk/index.js";
import * as Unsafe$dCoerce from "../Unsafe.Coerce/index.js";
const $ComponentSlot = (tag, _1) => ({tag, _1});
const traverse_ = /* #__PURE__ */ Data$dFoldable.traverse_(Control$dMonad$dFree.freeApplicative)(Data$dFoldable.foldableMaybe);
const ComponentSlot = value0 => $ComponentSlot("ComponentSlot", value0);
const ThunkSlot = value0 => $ComponentSlot("ThunkSlot", value0);
const unComponentSlot = Unsafe$dCoerce.unsafeCoerce;
const unComponent = Unsafe$dCoerce.unsafeCoerce;
const mkEval = args => v => {
  if (v.tag === "Initialize") {
    const $0 = traverse_(args.handleAction)(args.initialize);
    return Control$dMonad$dFree.$Free(
      $0._1,
      (() => {
        if ($0._2.tag === "CatNil") {
          return Data$dCatList.$CatList(
            "CatCons",
            x => Control$dMonad$dFree.$Free(Control$dMonad$dFree.$FreeView("Return", v._1), Data$dCatList.CatNil),
            Data$dCatQueue.$CatQueue(Data$dList$dTypes.Nil, Data$dList$dTypes.Nil)
          );
        }
        if ($0._2.tag === "CatCons") {
          return Data$dCatList.$CatList(
            "CatCons",
            $0._2._1,
            Data$dCatQueue.$CatQueue(
              $0._2._2._1,
              Data$dList$dTypes.$List(
                "Cons",
                Data$dCatList.$CatList(
                  "CatCons",
                  x => Control$dMonad$dFree.$Free(Control$dMonad$dFree.$FreeView("Return", v._1), Data$dCatList.CatNil),
                  Data$dCatQueue.$CatQueue(Data$dList$dTypes.Nil, Data$dList$dTypes.Nil)
                ),
                $0._2._2._2
              )
            )
          );
        }
        $runtime.fail();
      })()
    );
  }
  if (v.tag === "Finalize") {
    const $0 = traverse_(args.handleAction)(args.finalize);
    return Control$dMonad$dFree.$Free(
      $0._1,
      (() => {
        if ($0._2.tag === "CatNil") {
          return Data$dCatList.$CatList(
            "CatCons",
            x => Control$dMonad$dFree.$Free(Control$dMonad$dFree.$FreeView("Return", v._1), Data$dCatList.CatNil),
            Data$dCatQueue.$CatQueue(Data$dList$dTypes.Nil, Data$dList$dTypes.Nil)
          );
        }
        if ($0._2.tag === "CatCons") {
          return Data$dCatList.$CatList(
            "CatCons",
            $0._2._1,
            Data$dCatQueue.$CatQueue(
              $0._2._2._1,
              Data$dList$dTypes.$List(
                "Cons",
                Data$dCatList.$CatList(
                  "CatCons",
                  x => Control$dMonad$dFree.$Free(Control$dMonad$dFree.$FreeView("Return", v._1), Data$dCatList.CatNil),
                  Data$dCatQueue.$CatQueue(Data$dList$dTypes.Nil, Data$dList$dTypes.Nil)
                ),
                $0._2._2._2
              )
            )
          );
        }
        $runtime.fail();
      })()
    );
  }
  if (v.tag === "Receive") {
    const $0 = traverse_(args.handleAction)(args.receive(v._1));
    return Control$dMonad$dFree.$Free(
      $0._1,
      (() => {
        if ($0._2.tag === "CatNil") {
          return Data$dCatList.$CatList(
            "CatCons",
            x => Control$dMonad$dFree.$Free(Control$dMonad$dFree.$FreeView("Return", v._2), Data$dCatList.CatNil),
            Data$dCatQueue.$CatQueue(Data$dList$dTypes.Nil, Data$dList$dTypes.Nil)
          );
        }
        if ($0._2.tag === "CatCons") {
          return Data$dCatList.$CatList(
            "CatCons",
            $0._2._1,
            Data$dCatQueue.$CatQueue(
              $0._2._2._1,
              Data$dList$dTypes.$List(
                "Cons",
                Data$dCatList.$CatList(
                  "CatCons",
                  x => Control$dMonad$dFree.$Free(Control$dMonad$dFree.$FreeView("Return", v._2), Data$dCatList.CatNil),
                  Data$dCatQueue.$CatQueue(Data$dList$dTypes.Nil, Data$dList$dTypes.Nil)
                ),
                $0._2._2._2
              )
            )
          );
        }
        $runtime.fail();
      })()
    );
  }
  if (v.tag === "Action") {
    const $0 = args.handleAction(v._1);
    return Control$dMonad$dFree.$Free(
      $0._1,
      (() => {
        if ($0._2.tag === "CatNil") {
          return Data$dCatList.$CatList(
            "CatCons",
            x => Control$dMonad$dFree.$Free(Control$dMonad$dFree.$FreeView("Return", v._2), Data$dCatList.CatNil),
            Data$dCatQueue.$CatQueue(Data$dList$dTypes.Nil, Data$dList$dTypes.Nil)
          );
        }
        if ($0._2.tag === "CatCons") {
          return Data$dCatList.$CatList(
            "CatCons",
            $0._2._1,
            Data$dCatQueue.$CatQueue(
              $0._2._2._1,
              Data$dList$dTypes.$List(
                "Cons",
                Data$dCatList.$CatList(
                  "CatCons",
                  x => Control$dMonad$dFree.$Free(Control$dMonad$dFree.$FreeView("Return", v._2), Data$dCatList.CatNil),
                  Data$dCatQueue.$CatQueue(Data$dList$dTypes.Nil, Data$dList$dTypes.Nil)
                ),
                $0._2._2._2
              )
            )
          );
        }
        $runtime.fail();
      })()
    );
  }
  if (v.tag === "Query") {
    const $0 = v._2();
    const $1 = args.handleQuery(v._1._2);
    return Control$dMonad$dFree.$Free(
      $1._1,
      (() => {
        if ($1._2.tag === "CatNil") {
          return Data$dCatList.$CatList(
            "CatCons",
            x => Control$dMonad$dFree.$Free(
              Control$dMonad$dFree.$FreeView(
                "Return",
                (() => {
                  if (x.tag === "Nothing") { return $0; }
                  if (x.tag === "Just") { return v._1._1(x._1); }
                  $runtime.fail();
                })()
              ),
              Data$dCatList.CatNil
            ),
            Data$dCatQueue.$CatQueue(Data$dList$dTypes.Nil, Data$dList$dTypes.Nil)
          );
        }
        if ($1._2.tag === "CatCons") {
          return Data$dCatList.$CatList(
            "CatCons",
            $1._2._1,
            Data$dCatQueue.$CatQueue(
              $1._2._2._1,
              Data$dList$dTypes.$List(
                "Cons",
                Data$dCatList.$CatList(
                  "CatCons",
                  x => Control$dMonad$dFree.$Free(
                    Control$dMonad$dFree.$FreeView(
                      "Return",
                      (() => {
                        if (x.tag === "Nothing") { return $0; }
                        if (x.tag === "Just") { return v._1._1(x._1); }
                        $runtime.fail();
                      })()
                    ),
                    Data$dCatList.CatNil
                  ),
                  Data$dCatQueue.$CatQueue(Data$dList$dTypes.Nil, Data$dList$dTypes.Nil)
                ),
                $1._2._2._2
              )
            )
          );
        }
        $runtime.fail();
      })()
    );
  }
  $runtime.fail();
};
const mkComponentSlot = Unsafe$dCoerce.unsafeCoerce;
const mkComponent = Unsafe$dCoerce.unsafeCoerce;
const hoistSlot = dictFunctor => nat => v => {
  if (v.tag === "ComponentSlot") { return $ComponentSlot("ComponentSlot", {...v._1, component: hoist(dictFunctor)(nat)(v._1.component)}); }
  if (v.tag === "ThunkSlot") {
    return $ComponentSlot(
      "ThunkSlot",
      (() => {
        const $0 = v._1;
        return Halogen$dVDom$dThunk.$Thunk($0._1, $0._2, x => Halogen$dHTML$dCore.bifunctorHTML.bimap(hoistSlot(dictFunctor)(nat))(Data$dBifunctor.identity)($0._3(x)), $0._4);
      })()
    );
  }
  $runtime.fail();
};
const hoist = dictFunctor => nat => c => (
  {
    initialState: c.initialState,
    render: x => Halogen$dHTML$dCore.bifunctorHTML.bimap(hoistSlot(dictFunctor)(nat))(Data$dBifunctor.identity)(c.render(x)),
    eval: x => Halogen$dQuery$dHalogenM.hoist(dictFunctor)(nat)(c.eval(x))
  }
);
const functorComponentSlotBox = {
  map: f => slot => (
    {
      ...slot,
      output: x => {
        const $0 = slot.output(x);
        if ($0.tag === "Just") { return Data$dMaybe.$Maybe("Just", f($0._1)); }
        return Data$dMaybe.Nothing;
      }
    }
  )
};
const functorComponentSlot = {
  map: f => v => {
    if (v.tag === "ComponentSlot") {
      const $0 = v._1;
      return $ComponentSlot(
        "ComponentSlot",
        {
          ...$0,
          output: x => {
            const $1 = $0.output(x);
            if ($1.tag === "Just") { return Data$dMaybe.$Maybe("Just", f($1._1)); }
            return Data$dMaybe.Nothing;
          }
        }
      );
    }
    if (v.tag === "ThunkSlot") {
      return $ComponentSlot(
        "ThunkSlot",
        (() => {
          const $0 = Halogen$dHTML$dCore.bifunctorHTML.bimap(functorComponentSlot.map(f))(f);
          const $1 = v._1;
          return Halogen$dVDom$dThunk.$Thunk($1._1, $1._2, x => $0($1._3(x)), $1._4);
        })()
      );
    }
    $runtime.fail();
  }
};
const defaultEval = {
  handleAction: v => Control$dMonad$dFree.$Free(Control$dMonad$dFree.$FreeView("Return", undefined), Data$dCatList.CatNil),
  handleQuery: v => Control$dMonad$dFree.$Free(Control$dMonad$dFree.$FreeView("Return", Data$dMaybe.Nothing), Data$dCatList.CatNil),
  receive: v => Data$dMaybe.Nothing,
  initialize: Data$dMaybe.Nothing,
  finalize: Data$dMaybe.Nothing
};
const componentSlot = () => dictIsSymbol => dictOrd => {
  const lookup2 = Halogen$dData$dSlot.lookup()(dictIsSymbol)(dictOrd);
  const pop2 = Halogen$dData$dSlot.pop()(dictIsSymbol)(dictOrd);
  const insert2 = Halogen$dData$dSlot.insert()(dictIsSymbol)(dictOrd);
  return label => p => comp => input => output => ({get: lookup2(label)(p), pop: pop2(label)(p), set: insert2(label)(p), component: comp, input, output});
};
export {
  $ComponentSlot,
  ComponentSlot,
  ThunkSlot,
  componentSlot,
  defaultEval,
  functorComponentSlot,
  functorComponentSlotBox,
  hoist,
  hoistSlot,
  mkComponent,
  mkComponentSlot,
  mkEval,
  traverse_,
  unComponent,
  unComponentSlot
};
